// START IMPORTS
// Theme imports
import { createTheme } from '@ltvco/refresh-lib/theme';
// END IMPORTS

// START CONSTANTS
export const theme = createTheme({
  typography: {
    button: { textTransform: 'none', fontSize: '1rem', fontWeight: 'bold' },
    fontSize: 16,
    htmlFontSize: 16,
    fontFamily: "'Lato', sans-serif",
    h1: {
      fontSize: '1.875rem',
      fontWeight: 'bold',
      margin: '0 0 12px 0',
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      margin: '0 0 12px 0',
      lineHeight: 1.2,
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 'bold',
      margin: '0 0 12px 0',
      lineHeight: 1.2,
    },
    h4: {
      fontSize: '1.125rem',
      fontWeight: 'bold',
      margin: '0 0 12px 0',
      lineHeight: 1.2,
    },
    h5: {
      fontSize: '1rem',
      fontWeight: 'bold',
      margin: '0 0 12px 0',
      lineHeight: 1.2,
    },
    h6: {
      fontSize: '0.875rem',
      fontWeight: 'bold',
      margin: '0 0 12px 0',
      lineHeight: 1.2,
    },
    caption: {
      letterSpacing: 0,
      lineHeight: 1.2,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.2,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.2,
    },
  },
  components: {
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderRadius: 32,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: '#E2E2E2',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          input: {
            padding: 12,
          },
          div: {
            height: 40,
            backgroundColor: '#fff',
          },
          '& .MuiFormLabel-root': {
            top: -8,
          },
          '& .Mui-focused': {
            top: 0,
          },
          '& .MuiFormLabel-filled': {
            top: 0,
          },
        },
      },
    },
  },
  palette: {
    background: {
      paper: '#FFFFFF',
      default: '#F8F8F8',
      light: '#E6E7E9',
    },
    text: {
      primary: '#0A0B0D',
      secondary: '#5B616E',
      disabled: '#929AAB',
      contrastText: '#FFFFFF',
    },
    primary: {
      light: '#E2F4F9',
      main: '#24527B',
      dark: '#1E385A',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#33d4c1',
      dark: '#009173',
      light: '#d6f5f1',
      contrastText: '#ffffff',
    },
    divider: '#E6E7E9',
    button: {
      main: '#24527b',
      light: '#e2f4f9',
      dark: '#1E385A',
      contrastText: '#FFFFFF',
    },
    rats: {
      main: '#5B616E',
      light: '#F8F8F8',
      dark: '#24527B',
      contrastText: '#F8F8F8',
      activeHover: '#1E385A',
      disabled: '#929AAB',
    },
    buttonInverse: {
      main: '#FFFFFF',
      contrastText: '#0A0B0D',
      light: '#0A0B0D',
      dark: '#FFFFFF',
    },
    error: {
      main: '#DC0015',
      light: '#FFEDEA',
      dark: '#9A000E',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#4CAF50',
      light: '#EDF9EF',
      dark: '#388E3C',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#ED6C02',
      light: '#F08934',
      dark: '#9A000E',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#2196F3',
      light: '#64B5F6',
      dark: '#1976D2',
      contrastText: '#FFFFFF',
    },
    barChart: {
      main: '#24537B',
      light: '#E2E2E2',
      dark: '#C2E0E9',
      contrastText: '#000',
    },
    lineChart: {
      main: '#24537B',
      light: '#757575',
      dark: '#DC0015',
      contrastText: '#000',
    },
    charts: {
      primary: '#4C8DFF',
      secondary: '#5D4BFF',
      tertiary: '#1DA29A',
      positive: '#3CB963',
      caution: '#E46C0A',
      critical: '#FF3D3D',
      accent: '#D85FA6',
      decorative: '#00B8D9',
    },
    maps: {
      main: '#1F2E64',
      light: '#3388FF',
    },
    progress: {
      main: '#24537B',
      light: '#757575',
      dark: '#DC0015',
      contrastText: '#E2E2E2',
    },
    premium: {
      main: '#FCC41C',
    },
    threatDetection: {
      main: '#DC0015',
      light: '#E1FAEA',
      dark: '#81B44C',
      contrastText: '#FFF1F1',
    },
    monitorUpsell: {
      borderGradient:
        'linear-gradient(135deg, #A5C3FF 0%, #C4B8FF 45%, #E8B7D5 100%)',
      iconSurface: '#F8F8F8',
      divider: '#E2E2E2',
      bannerBackground:
        'linear-gradient(90deg, rgba(36, 83, 123, 0.75) 0%, rgba(31, 103, 49, 0.75) 100%)',
      iconCircle: '#FFFFFF',
      iconGlyph: '#5B7E9C',
      bannerForeground: '#FFFFFF',
      bannerCtaHoverBackground: 'rgba(255, 255, 255, 0.08)',
    },
  },
});
// END CONSTANTS
